import './depots-alerts.service';
import './depots-api.factory';
import './depots-dialogs-service.service';
import './depots-requests.service';
import './depots-service.service';
